import React from 'react'
import WelcomeNewTrialModal from './welcome-new-trial-modal'
import WelcomeStartTrialModal from './welcome-start-trial-modal'
import { useQueryState } from 'nuqs'
import { useNavigate } from 'react-router'

export enum EFreeTrialStatusType {
  NEW_TRIAL = 'new-trial', // New user login
  START_TRIAL = 'start-trial', // Returning user login
  ACTIVE_TRIAL = 'active-trial', // User in the free trial
  EXPIRED_TRIAL = 'expired-trial', // User's free trial has expired
  NO_TRIAL = 'no-trial', // User is not in a free trial
}

export const USER_FREE_TRAIL_STATUS_QUERY_KEY = 'trial_status'

interface Props {
  setJoyrideRun: any
}

export default function WelcomeFreeTrial({ setJoyrideRun }: Props) {
  const navigate = useNavigate()
  const [trialStatus, setTrialStatus] = useQueryState(
    USER_FREE_TRAIL_STATUS_QUERY_KEY
  )

  const onCloseModal = () => {
    setTrialStatus(null)
  }

  const navigateToTutorial = () => {
    onCloseModal()
    setTimeout(() => {
      navigate('/tutorial')
    }, 100)
  }

  const auth = JSON.parse(localStorage.getItem('auth') || '{}')
  const isShowTutorial = auth.tutorial

  return (
    <>
      <WelcomeNewTrialModal
        isOpen={
          (trialStatus === EFreeTrialStatusType.NEW_TRIAL ||
            trialStatus === EFreeTrialStatusType.ACTIVE_TRIAL) &&
          isShowTutorial
        }
        onHandleNext={navigateToTutorial}
        onHandleSkip={() => {
          setJoyrideRun(false)
          onCloseModal()
        }}
      />
      <WelcomeStartTrialModal
        isOpen={trialStatus === EFreeTrialStatusType.START_TRIAL}
        onHandleSkip={onCloseModal}
      />
    </>
  )
}
